"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var tools_1 = require("./tools");
var getAttrName = function (prop) {
    var name = prop.replace(/^allowed/, '').replace(/([^s])s$/, '$1');
    return name.charAt(0).toLocaleLowerCase() + name.substr(1);
};
var getNestedValue = function (val, valAllowed) {
    if (!valAllowed)
        return;
    if (!valAllowed.length)
        return val;
    var res = valAllowed[0];
    valAllowed.some(function (standardVal) {
        if (val <= standardVal) {
            res = standardVal;
            return false;
        }
        return true;
    });
    return res;
};
exports.getNestedValue = getNestedValue;
// 从大到小排序
var sortTypesetConfig = function (config) {
    // @ts-ignore
    return config.sort(function (a, b) {
        if (typeof b !== 'number')
            return;
        return b - a;
    });
};
// 返回默认值
var formatConfig = function (config) {
    var defaultValue;
    var values = false;
    if (config) {
        if (Array.isArray(config)) {
            values = sortTypesetConfig(config.map(function (val) {
                if (val instanceof Object) {
                    if (val.default)
                        defaultValue = val.value;
                    return val.value;
                }
                return val;
            }));
        }
        else if (config.default) {
            defaultValue = config.value;
            values = [];
        }
    }
    return { values: values, defaultValue: defaultValue };
};
// 格式化配置项
var getFormatAttrsByValue = function (allowedValues, attrName) {
    var _a = formatConfig(allowedValues), values = _a.values, defaultValue = _a.defaultValue;
    var formatAttrs = function (_attrs) {
        var _a;
        var val = getNestedValue(_attrs[attrName], values);
        if (val === defaultValue)
            return false;
        return _a = {}, _a[attrName] = val, _a;
    };
    return { formatAttrs: formatAttrs, values: values, defaultValue: defaultValue };
};
exports.getFormatAttrsByValue = getFormatAttrsByValue;
/**
 * 构造排版的attrs解析
 * @param config ITypesetProps，支持的配置项
 * @returns {number} defaultFontSize 默认字体大小，用于计算间距
 * @returns {Function} formatAttrs 用于根据config格式化输出attrs
 * @returns {Object} defaultAttrs 根据config构造的新的默认attrs
 */
var constructTypesetParseDOM = function (config) {
    var _a = config.defaultFontSize, defaultFontSize = _a === void 0 ? 16 : _a;
    var defaultAttrs = {};
    var getNestedValueByKey = {};
    var allowValues = {
        align: tools_1.SUPPORT_ALIGN
    };
    Object.keys(config).forEach(function (key) {
        if (!/^allowed/.test(key))
            return;
        var attrName = getAttrName(key);
        var _a = formatConfig(config[key]), values = _a.values, defaultValue = _a.defaultValue;
        defaultValue && (defaultAttrs[attrName] = { default: defaultValue });
        values && (allowValues[attrName] = values);
        // @ts-ignore
        getNestedValueByKey[attrName] = function (val) { return getNestedValue(val, values); };
    });
    var formatAttrs = function (attrs) {
        /**
         * * 不传，不接受所有值(默认)
         * * 传[], 接受所有值
         * * 其他['xx']情况按配置匹配
         */
        Object.keys(attrs).forEach(function (key) {
            var val = attrs[key];
            // 非数字，走匹配
            if (Number.isNaN(parseInt(val, 10))) {
                if (!allowValues[key]) {
                    attrs[key] = undefined;
                    return;
                }
                if (!allowValues[key].length)
                    return;
                var resVal = allowValues[key].includes(val) ? val : undefined;
                attrs[key] = resVal;
                return;
            }
            // @ts-ignore
            var formatFn = getNestedValueByKey[key];
            if (formatFn) {
                val !== undefined && val !== '' && (attrs[key] = formatFn(+val));
            }
            else {
                attrs[key] = undefined;
            }
        });
        return attrs;
    };
    return { defaultFontSize: defaultFontSize, formatAttrs: formatAttrs, defaultAttrs: defaultAttrs };
};
exports.constructTypesetParseDOM = constructTypesetParseDOM;
var formatMenuValues = function (attrsName, values, defaultVal) {
    if (values === void 0) { values = []; }
    if (defaultVal === void 0) { defaultVal = false; }
    var res = [];
    values.forEach(function (val) {
        var _a, _b;
        if (typeof val === 'object') {
            var config = __assign({}, val);
            if (val.value !== undefined)
                config.text = val.value;
            if (!val.attrs)
                config.attrs = val.default ? defaultVal : (_a = {}, _a[attrsName] = val.value, _a);
            res.push(config);
        }
        else {
            res.push({ text: val, attrs: (_b = {}, _b[attrsName] = val, _b) });
        }
    });
    return res;
};
exports.formatMenuValues = formatMenuValues;
//# sourceMappingURL=typeset.js.map